module.exports = "/fonts/gt-walsheim-regular.ttf";